export enum RegionVariant {
  Australia = "Australia",
  UK = "UK",
}
export enum CurrencyCode {
  AUD = "AUD",
  GBP = "GBP",
}
export enum Localisation {
  enAU = "en-AU",
  enGB = "en-GB",
}
export enum TimeFormat {
  TwelveHour = '12',
  TwentyFourHour = '24',
}